
export const ar = {
  // Navigation
  home: 'الرئيسية',
  flights: 'الطيران',
  hotels: 'الفنادق',
  buses: 'الباصات',
  cars: 'السيارات',
  myTrips: 'رحلاتي',
  profile: 'الملف الشخصي',
  
  // Common
  search: 'بحث',
  book: 'احجز',
  cancel: 'إلغاء',
  confirm: 'تأكيد',
  save: 'حفظ',
  edit: 'تعديل',
  delete: 'حذف',
  back: 'رجوع',
  next: 'التالي',
  previous: 'السابق',
  loading: 'جاري التحميل...',
  error: 'حدث خطأ',
  success: 'تم بنجاح',
  
  // Auth
  login: 'تسجيل الدخول',
  logout: 'تسجيل الخروج',
  register: 'إنشاء حساب',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  forgotPassword: 'نسيت كلمة المرور؟',
  
  // Booking
  from: 'من',
  to: 'إلى',
  departure: 'المغادرة',
  arrival: 'الوصول',
  date: 'التاريخ',
  time: 'الوقت',
  passengers: 'المسافرون',
  adults: 'البالغون',
  children: 'الأطفال',
  infants: 'الرضع',
  
  // Services
  wifi: 'واي فاي',
  meals: 'وجبات',
  baggage: 'حقائب',
  entertainment: 'ترفيه',
  
  // Language
  language: 'اللغة',
  arabic: 'العربية',
  english: 'English'
};
